import { render, staticRenderFns } from "./set-meal-detail.vue?vue&type=template&id=43932b84&scoped=true"
import script from "./set-meal-detail.vue?vue&type=script&lang=js"
export * from "./set-meal-detail.vue?vue&type=script&lang=js"
import style0 from "./set-meal-detail.vue?vue&type=style&index=0&id=43932b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43932b84",
  null
  
)

export default component.exports